import PageHeader, {
  HeaderContent,
  HeaderDivider,
  HeaderGroup,
  IconGroup,
} from '../../../../components/headers/HeaderBar/PageHeader'
import { DateTerm } from '../../../../../utils/date'
import SettingSpeedDial from '../../../../components/headers/HeaderBar/SettingSpeedDial'
import {
  DateRangeSelector,
  SearchUnit,
} from '../../../../components/headers/HeaderBar/DateRangeSelector'
import {
  ToolbarToggleGroup,
  ToolbarToggleValue,
} from '../../../../components/toolbars/Toolbar/ToolbarToggle'
import SplitButton, {
  SplitButtonProps,
} from '../../../../components/buttons/SplitButton'
import { featureFlagService } from '../../../../../utils/feature-flag'
import ReloadButton from '../../../../containers/BulkSheetView/components/header/ReloadButton'
import { ProxyProjectMemberSelector } from '../../../../components/headers/ProjectMemberSelector'
import { SelectOptionWithIcon } from '../../../../components/select/model'
import { UserDetail } from '../../../../../lib/functions/user'
import { intl } from '../../../../../i18n'

interface Props {
  onCancel: () => void
  searchUnit: SearchUnit
  dateTerm: DateTerm
  onSearch: (unit: SearchUnit, dateTerm: DateTerm) => void
  onClickExport: () => void
  toolbar: ToolbarToggleValue | undefined
  onChangeToolbar: (value: ToolbarToggleValue | undefined) => void
  rowHeight: number
  onChangeRowHeight: (value: number) => void
  splitButtonProps: SplitButtonProps
  projectUuid: string
  selectedMember: SelectOptionWithIcon<string> | undefined
  setSelectedMember: (member: SelectOptionWithIcon<string>) => void
  loginUser: UserDetail
  bulkSheetViewRef: React.RefObject<HTMLDivElement>
}

const ProxyRequestHeader = (props: Props) => {
  return (
    <>
      <ProxyProjectMemberSelector
        initialMessage={intl.formatMessage({
          id: 'taskActualWork.proxy.request.initial.message',
        })}
        message={intl.formatMessage({
          id: 'taskActualWork.proxy.request.message',
        })}
        selectedMember={props.selectedMember}
        setSelectedMember={props.setSelectedMember}
        projectUuid={props.projectUuid}
        loginUser={props.loginUser}
        height={props.bulkSheetViewRef.current?.offsetHeight}
        offset={20}
      />
      <PageHeader>
        <HeaderContent>
          <HeaderGroup>
            <ReloadButton onReload={props.onCancel} />
          </HeaderGroup>
          <HeaderGroup>
            <DateRangeSelector
              searchUnit={props.searchUnit}
              dateTerm={props.dateTerm}
              onSearch={props.onSearch}
            />
          </HeaderGroup>
          <HeaderDivider />
          <HeaderGroup>
            <IconGroup>
              <SettingSpeedDial
                onClickExport={props.onClickExport}
                rowHeight={props.rowHeight}
                onClickChangeRowHeight={props.onChangeRowHeight}
              />
            </IconGroup>
          </HeaderGroup>
          <ToolbarToggleGroup
            toggleItems={[ToolbarToggleValue.REPORT]}
            value={props.toolbar}
            onChange={props.onChangeToolbar}
            isNotice={false}
          />
          {featureFlagService.isEnabled('task-actual-work-application') && (
            <SplitButton
              options={props.splitButtonProps.options}
              disabled={props.splitButtonProps.disabled}
            />
          )}
        </HeaderContent>
      </PageHeader>
    </>
  )
}

export default ProxyRequestHeader
